module.exports = __webpack_public_path__ + "static/models/arch_start_ticker.0bd1a3f.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/track/models/arch_start_ticker.json
// module id = 537
// module chunks = 1